export default __webpack_public_path__ + "static/anaplan-logo-6736b37f3ba740a808e61976d22c17b7.png";